import * as d3 from 'd3';

export const yellowReds = [
    '#ffffcc',
    '#ffeda0',
    '#fed976',
    '#feb24c',
    '#fd8d3c',
    '#fc4e2a',
    '#e31a1c',
    '#bd0026',
    '#800026'
];

export const hexColors = d3.scaleQuantize()
  .domain([6, 100])
  .range(yellowReds);

export const opacityScale = d3.scaleQuantize()
  .domain([6, 100])
  .range([.2, .3, .4, .5, .6, .7, .8, .9]);

export const styleHexGrids = hexGrids => {
  hexGrids.features.forEach(c => {
      if (c.properties.hotspots > 0) {
          c.properties.color = hexColors(c.properties.hotspots);
          c.properties.opacity = opacityScale(c.properties.hotspots);
      } else {
          c.properties.opacity = 0;
      }
  });
  return hexGrids;
}
